/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit LastModifiedBy/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function LastModifiedBy({
  children,
  viewPath = "/DesignSystem/VerticalTimeline/VerticalTimelineForm/LastModifiedBy"
  
}) {
let timelineEventIsLastValueData = fromData.useDataValue({ viewPath,
context: 'timeline_event',
path: 'isLast',
})
let dtColorsNeutral600 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.600'
        })
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="small"
 color={dtColorsNeutral600}
 text={timelineEventIsLastValueData ? "Created by" : "Modified by"}
 data="timeline_event.isLast"
/>
{children}
</React.Fragment>)
}